import React, { Component } from 'react'

// redux
import { connect } from 'react-redux'
import ChartAction from '../../../redux/chart/actions'
import Card from '../../../componentsMaterial/Card/Card.jsx'
import CardHeader from '../../../componentsMaterial/Card/CardHeader.jsx'
import CardIcon from '../../../componentsMaterial/Card/CardIcon.jsx'
import CardBody from '../../../componentsMaterial/Card/CardBody.jsx'
import CardFooter from '../../../componentsMaterial/Card/CardFooter.jsx'
import Timeline from '@material-ui/icons/Timeline'
import ChartistGraph from 'react-chartist'
import chartsStyle from './chartsStyle'
import withStyles from '@material-ui/core/styles/withStyles'
import { TiMediaRecord } from 'react-icons/ti'
import moment from 'moment'
import { Pie } from 'react-chartjs-2'

import { DatePicker, Icon, Tooltip, Button, Dropdown, Menu } from 'antd'

const { MonthPicker, RangePicker } = DatePicker
// ui

// sub component

// props
// onSuccess(selectList): Khi nguoi dung lua chon
// onCancel(): khi nguoi dung khong chon
// initEvent: khoi tao select

let datachart = {}
let dataCount = []

class ChartTaskOfSystem extends Component {
    constructor(props) {
        super(props)
        var d = new Date()
        var n = d.getFullYear()
        this.state = {
            type: 0,
            year: n,
            month: 0,
            isHaveData: true,
            options: {},
        }
    }
    componentDidMount() {
        this.props.loadDataChartUserSystem(0, 0, 0)
    }

    componentWillReceiveProps = nextProps => {
        if (nextProps.TaskOfUserSystem !== this.props.TaskOfUserSystem) {
            let newTask = nextProps.TaskOfUserSystem.system_newly_implemented
            let actTask = nextProps.TaskOfUserSystem.system_act
            let finishTask = nextProps.TaskOfUserSystem.system_finish

            let seriesnewTask =
                ((newTask / (newTask + actTask + finishTask)) * 100) >> 0
            let seriesactTask =
                ((actTask / (newTask + actTask + finishTask)) * 100) >> 0
            let seriesfinishTask =
                finishTask === 0 ? 0 : 100 - seriesnewTask - seriesactTask

            dataCount = [seriesnewTask, seriesactTask, seriesfinishTask]
            let bool
            if (newTask === 0 && actTask === 0 && finishTask === 0) {
                bool = false
            } else {
                bool = true
            }
            this.setState({
                options: {
                    labels: [
                        'Nhiệm vụ mới triển khai',
                        'Nhiệm vụ đang làm',
                        'Nhiệm vụ đã kết thúc',
                    ],
                    datasets: [
                        {
                            backgroundColor: ['#44629e', '#3dbcd3', '#93d9cf'],
                            hoverBackgroundColor: [
                                '#44629e',
                                '#3dbcd3',
                                '#93d9cf',
                            ],
                            data: [
                                seriesnewTask,
                                seriesactTask,
                                seriesfinishTask,
                            ],
                        },
                    ],
                },
                isHaveData: bool,
            })
        }
    }
    getNameType = () => {
        switch (this.state.type) {
            case 0:
                return 'Chọn kiểu lọc'
            case 1:
                return 'Chọn theo tháng'
            case 2:
                return 'Chọn theo năm'

            default:
                return ''
            // code block
        }
    }
    disabledDate = current => {
        // Can not select days before today and today
        return current && current > moment().endOf('day')
    }
    onSelectYear = dataYear => {
        this.setState({ year: parseInt(dataYear.key) })
        const month = 0
        this.props.loadDataChartUserSystem(this.state.type, month, dataYear.key)
    }
    onChangeMonth = (date, dateString) => {
        const month = parseInt(dateString.slice(5))
        const year = parseInt(dateString.slice(0, 4))
        this.setState({ year, month })

        this.props.loadDataChartUserSystem(this.state.type, month, year)
    }

    render() {
        const { classes } = this.props
        const lstYear = [
            2018,
            2019,
            2020,
            2021,
            2022,
            2023,
            2024,
            2025,
            2026,
            2027,
            2028,
            2029,
            2030,
            2031,
            2032,
            2033,
            2034,
            2035,
            2036,
            2037,
            2038,
            2039,
            2040,
            2041,
            2042,
            2023,
            2044,
            2045,
            2046,
            2047,
            2048,
            2049,
            2050,
        ]
        var d = new Date()
        var n = d.getFullYear()
        const menuYearPicker = (
            <Menu>
                {lstYear.map(year => {
                    if (year <= n) {
                        return (
                            <Menu.Item
                                key={year}
                                onClick={year => this.onSelectYear(year)}
                            >
                                <Icon type="calendar" />
                                {year}
                            </Menu.Item>
                        )
                    }
                })}
            </Menu>
        )

        const menu = (
            <Menu>
                <Menu.Item key="1" onClick={() => this.setState({ type: 1 })}>
                    <Icon type="calendar" />
                    Lọc theo tháng
                </Menu.Item>
                <Menu.Item key="2" onClick={() => this.setState({ type: 2 })}>
                    <Icon type="calendar" />
                    Lọc theo năm
                </Menu.Item>

                <Menu.Item
                    key="4"
                    onClick={() => {
                        this.setState({ type: 0 })
                        this.props.loadDataChartUserSystem(0, 0, 0)
                    }}
                >
                    <Icon type="calendar" />
                    Tất cả
                </Menu.Item>
            </Menu>
        )
        return (
            <div style={{ width: '100%' }}>
                <Card
                    style={{
                        backgroundImage: `url(${require('../../../resource/image/blur-bg.jpg')}`,
                        backgroundSize: 'initial',
                        backgroundPosition: 'center',
                        height: 500,
                    }}
                >
                    <CardHeader color="rose" icon>
                        <CardIcon color="rose">
                            <Timeline />
                        </CardIcon>
                        <h4
                            style={{ color: 'white' }}
                            className={classes.cardIconTitle}
                        >
                            Nhiệm vụ của hệ thống
                        </h4>
                    </CardHeader>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            flexWrap: "wrap"
                        }}
                    >
                        <Dropdown overlay={menu}>
                            <Button style={{ marginRight: 20 }}>
                                {this.getNameType()}
                                <Icon type="down" />
                            </Button>
                        </Dropdown>
                        {this.state.type === 2 && (
                            <Dropdown overlay={menuYearPicker}>
                                <Button style={{ marginRight: 20 }}>
                                    {this.state.year}
                                    <Icon
                                        type="down"
                                        style={{ paddingLeft: 10 }}
                                    />
                                </Button>
                            </Dropdown>
                        )}

                        {this.state.type === 1 && (
                            <div>

                                <MonthPicker
                                    onChange={this.onChangeMonth}
                                    disabledDate={this.disabledDate}
                                    style={{ padding: 10 }}
                                    placeholder="Chọn tháng"
                                />
                            </div>
                        )}
                    </div>
                    <CardBody>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            {!this.state.isHaveData && (
                                <div>Không có dữ liệu</div>
                            )}
                            {this.state.isHaveData && (
                                <Pie
                                    data={this.state.options}
                                    ref={e => (this._chartRef = e)}
                                    options={{
                                        responsive: false,
                                        legend: {
                                            position: 'bottom',
                                            labels: {
                                                boxWidth: 30,
                                            },
                                            display: false,
                                        },
                                        tooltips: {
                                            callbacks: {
                                                label: function (tooltipItem) {
                                                    return (
                                                        dataCount[
                                                        tooltipItem.index
                                                        ] + ' %'
                                                    )
                                                },
                                            },
                                        },
                                    }}
                                />
                            )}
                        </div>
                    </CardBody>
                    <CardFooter className={classes.cardFooter}>
                        <h6
                            className={classes.legendTitle}
                            style={{ color: 'white' }}
                        >
                            Chú thích
                        </h6>
                        <div style={{ color: 'white' }}>
                            <i className={'fas fa-circle ' + classes.info} />{' '}
                            <TiMediaRecord color="#44629e" size={30} /> Nhiệm vụ
                            mới triển khai
                            {` `}
                        </div>

                        <div style={{ color: 'white' }}>
                            <i className={'fas fa-circle ' + classes.warning} />{' '}
                            <TiMediaRecord color="#3dbcd3" size={30} /> Nhiệm vụ
                            đang làm
                            {` `}
                        </div>
                        <div style={{ color: 'white' }}>
                            <i className={'fas fa-circle ' + classes.danger} />{' '}
                            <TiMediaRecord color="#93d9cf" size={30} /> Nhiệm vụ
                            đã kết thúc{` `}
                        </div>
                    </CardFooter>
                </Card>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        TaskOfUserSystem: state.chartReducer.TaskOfSystem,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        loadDataChartUserSystem: (typeFilter, month, year) => {
            dispatch(
                ChartAction.action.loadDataChartSystemTask(
                    typeFilter,
                    month,
                    year
                )
            )
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(chartsStyle)(ChartTaskOfSystem))
